import { useTranslation } from 'react-i18next';

import { Header } from '../../atoms/header/header';
import { AnimatedIllustration, AnimatedIllustrationName } from '../../atoms/illustration/animated-illustration';
import { Illustration } from '../../atoms/illustration/illustration';
import { Text } from '../../atoms/text/text';

const indigo200 = '#DCE3FE';
const mauve200 = '#F4E9FB';

type IllustrationTypes = {
  fill: string;
  image: AnimatedIllustrationName;
};

const womanWaitingIllustration: IllustrationTypes = {
  fill: mauve200,
  image: 'WomanWaitingAnimated',
};

const closedStoreIllustration: IllustrationTypes = {
  fill: indigo200,
  image: 'ClosedStoreAnimated',
};

const illustrationMap: Record<ErrorType, IllustrationTypes> = {
  ReferralPending: womanWaitingIllustration,
  InviteExpired: closedStoreIllustration,
  ReferralCancelled: closedStoreIllustration,
  InviteNotFound: closedStoreIllustration,
};

type ErrorType = 'ReferralCancelled' | 'InviteExpired' | 'ReferralPending' | 'InviteNotFound';

function ReportError({ error }: { readonly error: ErrorType }) {
  const { t } = useTranslation();

  const { fill, image } = illustrationMap[error];

  return (
    <div className="relative flex w-full h-[calc(100dvh-52px)]">
      <div className="flex flex-col justify-start items-start max-w-[30vw] pt-[20vh] ml-[30vh] z-2">
        <Header level="h1">{t(`page.report.errors.${error}.title`)}</Header>
        <Text size="lg" tag="p">
          {t(`page.report.errors.${error}.subtitle`)}
        </Text>
      </div>
      <AnimatedIllustration className="absolute right-0 pr-[40vh] pt-[10vh] h-[80vh] w-auto z-1" name={image} />
      <Illustration className="absolute right-0 z-0 h-[70vh] w-auto" fill={fill} name="Elipse1" />
      <Illustration className="absolute bottom-0 z-0 h-[70vh] w-auto" fill={fill} name="Elipse2" />
    </div>
  );
}

export { ReportError };
